import React from 'react';

import { Table } from 'semantic-ui-react';

import { multiCaseGet } from 'libs/format';

import ExternalAnchor from '../../../../../../../common/ExternalAnchor';
import { GoogleLocationPropType } from '../../../AccountSettings/AccountSettings.types';
import { getLocationAddressDisplay } from '../../AccountLocationList.utils';

const propTypes = {
  gmbLocation: GoogleLocationPropType.isRequired,
};

function LocationDetails({ gmbLocation }) {
  const locationDisplay = getLocationAddressDisplay(gmbLocation);
  const mapsUri = multiCaseGet(gmbLocation, 'metadata.mapsUri');
  const title = multiCaseGet(gmbLocation, 'title');

  return (
    <Table.Cell className="location-detail">
      <p>
        <strong>{title}</strong>
      </p>
      <p className="location-address">{locationDisplay || 'No address'}</p>
      {mapsUri && (
        <p>
          <ExternalAnchor href={mapsUri}>View on Google Maps</ExternalAnchor>
        </p>
      )}
    </Table.Cell>
  );
}

LocationDetails.propTypes = propTypes;

export default LocationDetails;
